import { render, staticRenderFns } from "./LabelStatisticsCreateNewFavoriteDialog.vue?vue&type=template&id=06969458"
import script from "./LabelStatisticsCreateNewFavoriteDialog.vue?vue&type=script&lang=js"
export * from "./LabelStatisticsCreateNewFavoriteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports